import LocationsEmpty from './LocationsEmpty';

export default LocationsEmpty;
